module.exports = __webpack_public_path__ + "static/img/title.e60f643e.png";